import React from 'react';
import cx from 'classnames';
import makeStyles from '@material-ui/core/styles/makeStyles';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableRow from '@material-ui/core/TableRow';
import TableCell from '@material-ui/core/TableCell';
import Chip from '@material-ui/core/Chip';
import useQueryParams from 'utils/useQueryParams';

const useStyles = makeStyles(theme => ({
  tableRoot: {
    marginTop: theme.spacing(1),
    width: 'unset'
  },
  cellRoot: {
    border: 0,
    padding: `0 ${theme.spacing(4)}px 0 0`,
    height: '40px'
  },
  cellName: {
    minWidth: '34em'
  },
  cellStatus: {
    minWidth: '10em'
  },
  chipRoot: {
    backgroundColor: '#fff',
    border: `1px solid ${theme.palette.grey[300]}`
  },
  radioGroupRoot: {
    display: 'block'
  },
  radioButtonRoot: {
    '& .MuiSvgIcon-root': {
      fontSize: '1.2rem'
    }
  },
  ppiLabelContainer: {
    userSelect: 'none'
  }
}));

// row = {
//    id,
//    name,
//    status,
//    actions
// }
const PpiTable = ({ rows = [], exclude }) => {
  const [itemCode, fromPpsiId, localPpiCopy] = useQueryParams(
    'itemCode',
    'fromPpsiId',
    'localPpiCopy'
  );
  const classes = useStyles();
  const showExlcude =
    (itemCode !== undefined && fromPpsiId !== undefined) ||
    (itemCode !== undefined && localPpiCopy === 'true');

  return (
    <Table classes={{ root: classes.tableRoot }}>
      <TableBody>
        {rows.map(({ id, name, status, actions, globalIngredientId = '' }) => {
          return (
            <>
              <TableRow key={id}>
                <TableCell
                  classes={{ root: cx(classes.cellRoot, classes.cellName) }}
                  key="name"
                >
                  {globalIngredientId ? `${globalIngredientId} ${name}` : name}
                </TableCell>
                <TableCell
                  classes={{ root: cx(classes.cellRoot, classes.cellStatus) }}
                  key="status"
                >
                  {status && (
                    <Chip
                      label={status}
                      size="medium"
                      classes={{ root: classes.chipRoot }}
                    />
                  )}
                </TableCell>
                <TableCell classes={{ root: classes.cellRoot }} key="actions">
                  {actions}
                </TableCell>
              </TableRow>
            </>
          );
        })}
        {!showExlcude && <TableRow key={Date.now()}>{exclude}</TableRow>}
      </TableBody>
    </Table>
  );
};

export default PpiTable;
